export default "__VITE_ASSET__TEa6vaAs__"